import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import ProductCard from './ProductCard';

const WishlistPage = () => {
  const { wishlist = [] } = useCart();

  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-32 px-6 max-w-[1600px] mx-auto">
      {/* Header Profile Area */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-16 border-b border-[#664229]/10 pb-8 gap-6">
        <div>
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] font-black text-[#F5F5DC] bg-[#2C1E12] px-4 py-2 mb-6 rounded-sm shadow-md hover:bg-[#664229] transition-all duration-300 transform hover:-translate-x-1 no-underline"
          >
            <span>←</span> <span>Continue Shopping</span>
          </Link>
          <h1 className="text-4xl font-extrabold tracking-tighter text-[#2C1E12] uppercase leading-none">
            YOUR WISHLIST
          </h1>
        </div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#664229] bg-[#E5D3B3] font-bold px-3 py-1.5 rounded-sm h-fit">
          Saved Items: {wishlist.length}
        </p>
      </div>

      {/* Grid Layout Canvas */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {wishlist.length > 0 ? (
          wishlist.map(product => {
            const productId = product._id || product.id;
            return (
              <ProductCard 
                key={productId} 
                id={productId}
                _id={productId}
                name={product.name}
                price={product.price}
                discountPrice={product.discountPrice} 
                images={product.images || [product.image]} 
                image={product.image || (product.images && product.images[0])}
                product={product}
              />
            );
          })
        ) : (
          <div className="col-span-full text-center py-24 text-[#664229]/50 text-xs tracking-widest uppercase border border-dashed border-[#664229]/20 rounded-sm">
            Your wishlist room is currently empty. Explore items to save favourites.
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;